/** Chemins et clés pour la purge SSO cross-origin (iframe statique). */
export const LOGOUT_SYNC_STATIC_PATH = "/auth/logout-sync.html";
export const LOGOUT_SYNC_REACT_PATH = "/auth/logout-sync";

export const LOGOUT_SYNC_AUTH_KEYS = [
  "itaas.auth.accessToken",
  "itaas.auth.refreshToken",
  "itaas.auth.userId",
  "itaas.auth.tenantId",
  "itaas.auth.expiresAt",
  "itaas.auth.session",
  "itaas.auth.lastRefreshProbe",
] as const;

export const LOGOUT_SYNC_SUITE_KEYS = [
  "itaas.suite.lastModule",
  "itaas.suite.returnTo",
  "itaas.suite.returnToPath",
  "itaas.suite.sessionSeededAt",
] as const;

export const LOGOUT_SYNC_SSO_PREFIX = "itaas_sso_relay:";
